import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_InputSeparator = _resolveComponent("InputSeparator")!
  const _component_k_textbox = _resolveComponent("k-textbox")!

  return (_openBlock(), _createBlock(_component_k_textbox, {
    placeholder: `${_ctx.localize('search')}...`,
    modelValue: _ctx.searchText,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
    "input-prefix": "prefix",
    "show-clear-button": true,
    onChange: _ctx.onChanged
  }, {
    prefix: _withCtx(() => [
      _createVNode(_component_my_icon, {
        icon: "zoom",
        size: 16
      }),
      _createVNode(_component_InputSeparator)
    ]),
    _: 1
  }, 8, ["placeholder", "modelValue", "onChange"]))
}